import { render, staticRenderFns } from "./VatAnaliticsDetails.vue?vue&type=template&id=135466f1&scoped=true&"
import script from "./VatAnaliticsDetails.vue?vue&type=script&lang=ts&"
export * from "./VatAnaliticsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./VatAnaliticsDetails.vue?vue&type=style&index=0&id=135466f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135466f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSwitch,VTooltip})
